import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuthState } from "./provider/AuthProvider";
import { ConfigProvider } from "antd";

import "./App.css";

import * as Common from "./commons/common";

import PageLayout from "./layout/PageLayout";
import Welcome from "./pages/Welcome";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Tos from "./pages/Tos";
import Privacy from "./pages/Privacy";
import MyPage from "./pages/MyPage";
import UpdateMember from "./pages/UpdateMember";
import WithdrawMember from "./pages/WithdrawMember";
import Main from "./pages/Main";
import FindEVStation from "./pages/FindEVStation";
import Settings from "./pages/Settings";
import RegisterCar from "./pages/RegisterCar";
import ManageCar from "./pages/ManageCar";
import ChangePassword from "./pages/ChangePassword";
import CompanyInfo from "./pages/CompanyInfo";
import AlertPopup from "./components/AlertPopup";
import RegisterCarMethod from "./pages/RegisterCarMethod";
import WithDrawalInfo from "./pages/WithDrawalInfo";

declare const window: typeof globalThis & {
    IMP: any;
};

const PrivateRoute = (props: any) => {
    const userDetails = useAuthState();

    if (props.role && props.role.length > 0) {
        const checkRole = userDetails?.user && props.role.includes(userDetails?.user.authority);
        return checkRole ? (
            props.children
        ) : (
            <PageLayout>
                <Login />
            </PageLayout>
        );
    }

    return userDetails?.user ? props.children : <Navigate to={Common.PAGE_LOGIN} replace={true} />;
};

function App() {
    useEffect(() => {
        const { IMP } = window;
        IMP.init("imp93949381");
    }, []);

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: "Noto Sans KR, sans-serif",
                },
            }}
        >
            <AlertPopup />

            <Routes>
                <Route path="/" element={<Navigate to={Common.PAGE_WELCOME} />} />
                <Route path={Common.PAGE_WELCOME} element={<Welcome />} />
                <Route
                    path={Common.PAGE_LOGIN}
                    element={
                        <PageLayout headerType={{ leftType: "none", title: "로그인" }}>
                            <Login />
                        </PageLayout>
                    }
                />
                <Route
                    path={Common.PAGE_SIGNUP}
                    element={
                        <PageLayout headerType={{ title: "통합 회원 가입" }}>
                            <SignUp />
                        </PageLayout>
                    }
                />
                <Route
                    path={Common.PAGE_TOS}
                    element={
                        <PageLayout headerType={{ title: "서비스 이용약관" }}>
                            <Tos />
                        </PageLayout>
                    }
                ></Route>
                <Route
                    path={Common.PAGE_PRIVACY}
                    element={
                        <PageLayout headerType={{ title: "개인정보 수집 및 이용" }}>
                            <Privacy />
                        </PageLayout>
                    }
                />
                <Route
                    path={Common.PAGE_MYPAGE}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "계정정보" }}>
                                <MyPage />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_UPDATE_MEMBER}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "내 정보 수정" }}>
                                <UpdateMember />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_WITHDRAW_MEMBER}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "통합 회원 탈퇴" }}>
                                <WithdrawMember />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_MAIN}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ leftType: "logo", rightType: "setting", subRightType: "mainPowerPopup" }}>
                                <Main />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_FIND_EV_STATION}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "충전소 찾기", rightType: "info" }}>
                                <FindEVStation />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_SETTINGS}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "설정" }}>
                                <Settings />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_REGISTER_CAR}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "차량 등록", rightType: "info" }}>
                                <RegisterCar />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_REGISTER_CAR_METHOD}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "QR 코드 스캔 방법" }}>
                                <RegisterCarMethod />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_MANAGE_CAR}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "내 차량 관리" }}>
                                <ManageCar />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_CHANGE_PASSWORD}
                    element={
                        <PageLayout headerType={{ title: "비밀번호 재설정" }}>
                            <ChangePassword />
                        </PageLayout>
                    }
                />
                <Route
                    path={Common.PAGE_COMPANY_INFO}
                    element={
                        <PrivateRoute>
                            <PageLayout headerType={{ title: "사업자 정보" }}>
                                <CompanyInfo />
                            </PageLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_WITHDRAWL_INFO}
                    element={
                        <PageLayout headerType={{ leftType: "none", title: "통합회원 탈퇴 안내" }}>
                            <WithDrawalInfo />
                        </PageLayout>
                    }
                />
            </Routes>
        </ConfigProvider>
    );
}

export default App;
